import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
  where,
  limit,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebase";
import { Edicao, EdicaoForm } from "@/types/edicao";

export async function uploadImagemEdicao(file: File, edicaoId: string, campo: "atracoes" | "mapa"): Promise<string> {
  const ext = file.name.split(".").pop();
  const storageRef = ref(storage, `edicoes/${edicaoId}/${campo}_${Date.now()}.${ext}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

const COL = "edicoes";

function mapearEdicao(d: any): Edicao {
  const data = d.data();
  return {
    id: d.id,
    cidade: data.cidade,
    uf: data.uf,
    nomeLocal: data.nomeLocal,
    data: data.data,
    listaEspera: data.listaEspera,
    limiteListaEspera: data.limiteListaEspera ?? null,
    atracoes: data.atracoes ?? [],
    linkIngressos: data.linkIngressos ?? "",
    linkMaps: data.linkMaps ?? "",
    fotoAtracoes: data.fotoAtracoes ?? "",
    fotoMapa: data.fotoMapa ?? "",
    criadoEm: (data.criadoEm as Timestamp)?.toDate() ?? new Date(),
    atualizadoEm: (data.atualizadoEm as Timestamp)?.toDate() ?? new Date(),
  } as Edicao;
}

export async function criarEdicao(dados: EdicaoForm): Promise<string> {
  const ref = await addDoc(collection(db, COL), {
    ...dados,
    criadoEm: serverTimestamp(),
    atualizadoEm: serverTimestamp(),
  });
  return ref.id;
}

export async function atualizarEdicao(id: string, dados: EdicaoForm): Promise<void> {
  await updateDoc(doc(db, COL, id), {
    ...dados,
    atualizadoEm: serverTimestamp(),
  });
}

export async function deletarEdicao(id: string): Promise<void> {
  await deleteDoc(doc(db, COL, id));
}

export async function buscarProximaEdicao(): Promise<Edicao | null> {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const hojeStr = hoje.toISOString().split('T')[0];
  
  // Busca a próxima edição futura (a mais próxima)
  const qFutura = query(
    collection(db, COL),
    where("data", ">=", hojeStr),
    orderBy("data", "asc"),
    limit(1)
  );
  
  const snapFutura = await getDocs(qFutura);
  if (!snapFutura.empty) {
    return mapearEdicao(snapFutura.docs[0]);
  }
  
  // Se não houver edições futuras, busca a mais recente
  const qRecente = query(
    collection(db, COL),
    orderBy("data", "desc"),
    limit(1)
  );
  
  const snapRecente = await getDocs(qRecente);
  return snapRecente.empty ? null : mapearEdicao(snapRecente.docs[0]);
}

export async function listarEdicoes(): Promise<Edicao[]> {
  const q = query(collection(db, COL), orderBy("data", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(mapearEdicao);
}
